module.exports = __webpack_public_path__ + "assets/img/wback1.0cb2f815.png";